module.exports = __webpack_public_path__ + "03_short_gold.e49ad0fd.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/okuta/mom/layer5/03_short_gold.png
// module id = 3BhY
// module chunks = 0